import { css } from '@/styled-system/css';

// Filled white circle with shadow so the buttons read clearly against listing
// photos / busy carousel backgrounds. Constellation's bare `tone="neutral"
// emphasis="filled"` defaults blend into the page background for our use case.
// Keep buttons inside the carousel so the nav affordance cannot widen the document.
export const prevButton = css({
  position: 'absolute',
  bottom: '50%',
  zIndex: 1,
  background: 'bg.neutral',
  boxShadow: 'md',
  transform: 'translate3d(0, 50%, 0)',
  _hover: { background: 'bg.softest' },
  left: '0',
});

export const nextButton = css({
  position: 'absolute',
  bottom: '50%',
  zIndex: 1,
  background: 'bg.neutral',
  boxShadow: 'md',
  transform: 'translate3d(0, 50%, 0)',
  _hover: { background: 'bg.softest' },
  right: '0',
});
